export default __webpack_public_path__ + "static/media/14.a095a0e5.png";